<dynamic-form
  [group]="formGroup"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [label]="'ClientApp.FrontOffice.Order.OrderOnline.SuccessOrder' | translate">
  <ng-container class="content">
    <div class="page">
      <ssg-input
        [label]="'ClientApp.FrontOffice.Order.OrderOnline.CookingTime' | translate"
        [group]="formGroup"
        name="CookingTime"
        (valueChange)="onCookingTimeChange($event)"></ssg-input>
      <ssg-input
        *ngIf="!model.IsPickupOrder"
        [label]="'ClientApp.FrontOffice.Order.OrderOnline.SendingTime' | translate"
        [group]="formGroup"
        name="SendingTime"
        class="send-time"></ssg-input>
    </div>
  </ng-container>
</dynamic-form>
